"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootDocumentSagas = void 0;
var RootPublicPageSaga_1 = require("@/pages/common/sagas/RootPublicPageSaga");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var effects_1 = require("redux-saga/effects");
var Pages_1 = require("@/rendering/common/Pages");
var MyDocumentApiSaga_1 = require("@/pages/document/sagas/api/MyDocumentApiSaga");
var DocumentAction_1 = require("@/pages/document/actions/DocumentAction");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var EformDtoToEformState_1 = require("@/pages/document/transformers/EformDtoToEformState");
var WindowApi_1 = require("@/api/browser/WindowApi");
var DocumentSortToListingOrderAndDir_1 = require("@/pages/document/transformers/DocumentSortToListingOrderAndDir");
var ListOrderEnum_1 = require("@/pages/document/states/ListOrderEnum");
var getIsPending = function (state) { return state.page === Pages_1.Pages.PENDING_DOCUMENT; };
var initPendingDocuments = function (page, sort, isAsc) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(MyDocumentApiSaga_1.getPendingDocumentApi, page, sort, isAsc)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
};
var initSignedDocuments = function (page, sort, isAsc) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(MyDocumentApiSaga_1.getSignedDocumentApi, page, sort, isAsc)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
};
var loadPage = function (page, sort, isAsc) {
    var lang, email, isPendingPage, result, eforms;
    if (page === void 0) { page = 1; }
    if (sort === void 0) { sort = ListOrderEnum_1.ListOrderEnum.CREATED_DATE; }
    if (isAsc === void 0) { isAsc = false; }
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 1:
                lang = _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getUserEmail)];
            case 2:
                email = _a.sent();
                return [4 /*yield*/, effects_1.select(getIsPending)];
            case 3:
                isPendingPage = _a.sent();
                return [4 /*yield*/, effects_1.call(isPendingPage ? initPendingDocuments : initSignedDocuments, page, sort, isAsc)];
            case 4:
                result = _a.sent();
                if (!result || !result.results)
                    return [2 /*return*/];
                eforms = result.results.map(EformDtoToEformState_1.EformDtoToEformState(lang, email.toLowerCase()));
                return [4 /*yield*/, effects_1.put(DocumentAction_1.default.setResult(eforms, result.currentPage, result.totalPage, result.totalRecords))];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchOnInit = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_DOM_LOADED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(loadPage)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchOnView = function () {
    var payload, key, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(DocumentAction_1.default.DOCUMENT_ON_VIEW_CLICKED_BY_DOCUMENT_PATH)];
            case 1:
                payload = (_a.sent()).payload;
                key = payload;
                return [4 /*yield*/, effects_1.call(MyDocumentApiSaga_1.getDownloadUrl, key)];
            case 2:
                result = _a.sent();
                if (!(result && result.url)) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.call(WindowApi_1.openTab, result.url)];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var watchOnChangePage = function () {
    var payload, page;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(DocumentAction_1.default.DOCUMENT_ON_CHANGE_PAGE)];
            case 1:
                payload = (_a.sent()).payload;
                page = payload;
                return [4 /*yield*/, effects_1.call(loadPage, page)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchOnSortChanged = function () {
    var payload, sort, _a, listOrder, isAsc;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(DocumentAction_1.default.DOCUMENT_ON_DOCUMENT_SORT)];
            case 1:
                payload = (_b.sent()).payload;
                sort = payload;
                return [4 /*yield*/, effects_1.call(DocumentSortToListingOrderAndDir_1.DocumentSortToListingOrderAndDir, sort)];
            case 2:
                _a = _b.sent(), listOrder = _a.listOrder, isAsc = _a.isAsc;
                return [4 /*yield*/, effects_1.call(loadPage, 1, listOrder, isAsc)];
            case 3:
                _b.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var rootDocumentSagas = {
    rootPublicPageSagas: RootPublicPageSaga_1.rootPublicPageSagas,
    watchOnInit: watchOnInit,
    watchOnView: watchOnView,
    watchOnChangePage: watchOnChangePage,
    watchOnSortChanged: watchOnSortChanged,
};
exports.rootDocumentSagas = rootDocumentSagas;
